export default "__VITE_ASSET__CMlkMeDX__"